<template>
     <div @click="$emit('coverSelected', num)" class="cover photo_book_cover_list_item">
        <div class="loader" v-if="loading"></div>
        
        <div class="overlay-container" 
             :class="{ 'show-overlay': isSelected || isHovered }"
             @mouseenter="isHovered = true"
             @mouseleave="isHovered = false">
             
            <div class="rejac text-light justify-content-center flex-column text-center">
                <div class="col"></div>
                
                <div class="col-auto">
                    <div class="icon icon-shape text-dark rounded-circle shadow" style="background-color: rgba(255, 255, 255, 0.8);">
                        {{ num }} 
                    </div>
                    <p></p>
                    <p v-if="state == 'accepted'">
                        
                        <strong>Layout accepted</strong>
                    </p>

                    <p v-if="state == 'rejected'">
                        
                        <strong>Layout rejected</strong>
                    </p>

                    <p v-if="state == 'revised'">
                        <i class="ni ni-settings"></i>
                        change requested
                    </p>
                </div>
                
                <div class="col"></div>
            </div>  
        </div>

        <b-img-lazy class="coverthumb" :src="url" alt=""></b-img-lazy>
     </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Modal, BaseAlert } from '@/components'

export default {
    name: "photo-book-cover-list-item",
    components: {
        Modal,
        BaseAlert,
    },
    props: {
        url: String,
        num: Number,
        big: Boolean,
        state: String,
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            isHovered: false
        };
    },
    methods: {
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount', currentPhotoBook: 'currentPhotoBook' }),
    },
    mounted() {
        console.log("Mounted bppli:"+this.url);
        console.log("Mounted bppli_id:"+this.num);
        console.log("Mounted bppli_id:"+this.num+" STATE => "+this.state);
    },
};
</script>
<style scoped>
.landscape {
    width: 297mm;
    height: 210mm;

    width: 104px;
    height: 74px;
}

.portrait {
    height: 297mm;
    width: 210mm;

    height: 104px;
    width: 74px;
}

.cover_overlay {
    background-color: green;
    display: block;

    margin: 0 auto;
    margin-bottom: 0.5cm;
    float: left;
}

    #bg-image > .mask { display: none; }
    #bg-image:hover > .mask { display: flex; }
    #bg-image:hover > .rejac { display: none !important; }

    .rejac
    {
        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;

        transition: all .15s ease;
    }
    @media (prefers-reduced-motion: reduce)
    {
        .rejac
        {
            transition: none;
        }
    }

.page {
    background: white;
    display: block;
    margin: 0 auto;
    margin-bottom: 0.5cm;
    box-shadow: 0 0 0.3cm rgba(0, 0, 0, 0.5);
    float: left;
}

.coverthumb {
    width: 100%;
}

.overlay-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 1;
}

.overlay-container.show-overlay {
    opacity: 1;
}

.rejac {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    margin: 0;
    width: 100%;
    height: 100%;
}

.cover {
    position: relative;
    display: block;
    width: 100%;
}

.coverthumb {
    width: 100%;
    display: block;
    position: relative;
}

/* Remove any margin/padding from parent containers that might affect positioning */
.photo_book_cover_list_item {
    position: relative;
    padding: 0;
    margin: 0;
}

</style>